import { render } from "./ContainerWhite.vue?vue&type=template&id=538e240a&scoped=true"
import script from "./ContainerWhite.vue?vue&type=script&lang=js"
export * from "./ContainerWhite.vue?vue&type=script&lang=js"

import "./ContainerWhite.vue?vue&type=style&index=0&id=538e240a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538e240a"]])

export default __exports__